<po-page-default p-title="Atas - Sócios - Domínio" [p-breadcrumb]="breadcrumb"
    p-subtitle="Gere o documento de Atas - Sócios baseado nas informações da base de dados do sistema Domínio.">

    <!-- Resumo da página -->
    <div class="page-summary">
        <div class="page-summary-icon">
            <i class="an an-file-text"></i>
        </div>
        <div class="page-summary-text">
            <p class="po-font-subtitle po-mb-0">Geração de Documento - Atas &amp; Sócios</p>
            <p class="page-summary-hint">Preencha os campos abaixo e clique em <b>Gerar</b> para processar o documento automaticamente.</p>
        </div>
    </div>

    <po-divider></po-divider>

    <form #form="ngForm" (ngSubmit)="requestAtasSocios(form)">

        <!-- Seção: Dados do Documento -->
        <div class="atas-section po-mt-3">
            <div class="atas-section-header">
                <i class="an an-gear-six"></i>
                <span>Configurações do Documento</span>
            </div>
            <div class="atas-section-body">
                <div class="po-row">
                    <app-empresa-combo class="po-lg-4 po-md-6 po-sm-12" name="idEmpresa" [(ngModel)]="idEmpresa"
                        label="Empresa"
                        placeholder="Buscar por código ou nome da empresa..."
                        help="Digite o código (Domínio) ou o nome da empresa para buscar.">
                    </app-empresa-combo>

                    <po-input #valorInput class="po-lg-4 po-md-6 po-sm-12" name="valor" [(ngModel)]="valorDisplay"
                        p-icon="an an-currency-circle-dollar" p-label="Valor" p-placeholder="R$ 0,00"
                        p-help="Valor considerado na geração do documento" p-required="true"
                        p-name="valor">
                    </po-input>

                    <po-input class="po-lg-4 po-md-6 po-sm-12" p-label="Cód. Jucesp" name="codJucesp" p-icon="an an-barcode"
                        [(ngModel)]="codJucesp" p-placeholder="Cód. Jucesp" p-help="Informe o código Jucesp"
                        p-required="true" p-name="codJucesp">
                    </po-input>
                </div>

                <div class="atas-action-row po-mt-3">
                    <po-button p-label="Gerar Atas - Sócios" p-icon="an an-paper-plane-tilt"
                        (p-click)="requestAtasSocios(form)">
                    </po-button>
                </div>
            </div>
        </div>

        <!-- Seção: Informações -->
        <div class="atas-section po-mt-3">
            <div class="atas-section-header">
                <i class="an an-info"></i>
                <span>Como funciona</span>
            </div>
            <div class="atas-section-body">
                <div class="atas-info-steps">
                    <div class="atas-info-step">
                        <div class="atas-step-number">1</div>
                        <div class="atas-step-content">
                            <p class="atas-step-title">Preencha os campos</p>
                            <p class="atas-step-desc">Selecione a empresa, informe o valor e o código Jucesp.</p>
                        </div>
                    </div>
                    <div class="atas-info-step">
                        <div class="atas-step-number">2</div>
                        <div class="atas-step-content">
                            <p class="atas-step-title">Processamento automático</p>
                            <p class="atas-step-desc">O sistema utilizará as informações do banco de dados do Domínio para gerar o documento de Atas - Sócios.</p>
                        </div>
                    </div>
                    <div class="atas-info-step">
                        <div class="atas-step-number">3</div>
                        <div class="atas-step-content">
                            <p class="atas-step-title">Receba por e-mail</p>
                            <p class="atas-step-desc">Após o processamento, o documento será enviado para o e-mail cadastrado em seu usuário. O processo pode levar alguns minutos.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </form>
</po-page-default>

